"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useState } from "react";
import type { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
import ProxyCreateActionSelectType from "./select-type/ProxyCreateActionSelectType";
import CommonChangeAnimation from "@/components/utils/animation/CommonChangeAnimation";
import type { ApiProfileProxyActionType } from "@/generated/models/ApiProfileProxyActionType";
import ProxyCreateActionConfig from "./config/ProxyCreateActionConfig";
import type { CreateProxyAction } from "@/entities/IProxy";
import { useMutation } from "@tanstack/react-query";
import { commonApiPost } from "@/services/api/common-api";
import { AuthContext } from "@/components/auth/Auth";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
export default function ProxyCreateAction(t0) {
  const $ = _c(22);
  const {
    profileProxy,
    onActionCreated,
    onCancel
  } = t0;
  const {
    setToast,
    requestAuth
  } = useContext(AuthContext);
  const {
    onProfileProxyModify
  } = useContext(ReactQueryWrapperContext);
  const [selectedActionType, setSelectedActionType] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  let t1;
  if ($[0] !== profileProxy) {
    t1 = async action => await commonApiPost({
      endpoint: `proxies/${profileProxy.id}/actions`,
      body: action
    });
    $[0] = profileProxy;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onActionCreated || $[3] !== onProfileProxyModify || $[4] !== profileProxy) {
    t2 = () => {
      if (!profileProxy.granted_to?.handle || !profileProxy.created_by?.handle) {
        return;
      }
      onProfileProxyModify({
        profileProxyId: profileProxy.id
      });
      onActionCreated();
    };
    $[2] = onActionCreated;
    $[3] = onProfileProxyModify;
    $[4] = profileProxy;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== setToast) {
    t3 = error => {
      setToast({
        message: error as unknown as string,
        type: "error"
      });
    };
    $[6] = setToast;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setSubmitting(false);
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t5 = {
      mutationFn: t1,
      onSuccess: t2,
      onError: t3,
      onSettled: t4
    };
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const createProxyActionMutation = useMutation(t5);
  let t6;
  if ($[13] !== createProxyActionMutation || $[14] !== requestAuth) {
    t6 = async action_0 => {
      setSubmitting(true);
      const {
        success
      } = await requestAuth();
      if (!success) {
        setSubmitting(false);
        return;
      }
      await createProxyActionMutation.mutateAsync(action_0);
    };
    $[13] = createProxyActionMutation;
    $[14] = requestAuth;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const onSubmit = t6;
  let t7;
  if ($[16] !== onCancel || $[17] !== onSubmit || $[18] !== profileProxy || $[19] !== selectedActionType || $[20] !== submitting) {
    t7 = <div><CommonChangeAnimation>{!selectedActionType ? <ProxyCreateActionSelectType setSelectedActionType={setSelectedActionType} currentActions={profileProxy.actions} onCancel={onCancel} /> : <div><ProxyCreateActionConfig selectedActionType={selectedActionType} submitting={submitting} onSubmit={onSubmit} onCancel={() => setSelectedActionType(null)} /></div>}</CommonChangeAnimation></div>;
    $[16] = onCancel;
    $[17] = onSubmit;
    $[18] = profileProxy;
    $[19] = selectedActionType;
    $[20] = submitting;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}